export default "__VITE_PUBLIC_ASSET__db08af2e__"